import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import axios from 'axios';

// Shadcn cn utility
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Format currency - LEK të reja
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('sq-AL', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount) + ' LEK';
};

// Format date
export const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('sq-AL', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

// Format datetime
export const formatDateTime = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('sq-AL', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

// Get status badge class
export const getStatusBadgeClass = (status) => {
  const statusMap = {
    active: 'badge-success',
    expired: 'badge-danger',
    pending: 'badge-warning',
    in_progress: 'badge-info',
    completed: 'badge-success',
    cancelled: 'badge-danger',
  };
  return statusMap[status] || 'badge-info';
};

// Get status label in Albanian
export const getStatusLabel = (status) => {
  const labels = {
    active: 'Aktive',
    expired: 'Skaduar',
    pending: 'Në pritje',
    in_progress: 'Në punë',
    completed: 'Përfunduar',
    cancelled: 'Anuluar',
  };
  return labels[status] || status;
};

// Generate random barcode
export const generateBarcode = () => {
  const prefix = '200';
  const random = Math.floor(Math.random() * 10000000000).toString().padStart(10, '0');
  return prefix + random.slice(0, 9);
};
